import { useBack } from "@website/hooks/back";

import { getChannel } from "@website/utils/channel/get-channel";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isChannel } from "@website/utils/channel/helpers";
import { allServices } from "@website/widget/header/hooks/constants";
import { useRouter } from "next/router";
import { useMemo } from "react";

export const useServices = () => {
  const { goBack } = useBack();
  const router = useRouter();
  const channel = getChannel();

  const services = useMemo(() => {
    const filtered =
      isChannel(["ads"]) || getOrigin()?.includes("flight")
        ? allServices.filter(
            (service) =>
              service.url === "/flights" || service.url === "/inter-flights"
          )
        : allServices;
    // Update selected property based on current route
    return filtered.map((service) => ({
      ...service,
      selected: router.pathname === service.url
    }));
  }, [router, channel]);

  return {
    services,
    onGoBack: goBack
  };
};
